// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__23jut","label":"Labeled_label__3NYOV","divider":"Labeled_divider__uI-tG"};